require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-black-friday-cyber-monday-customer-service.json") })
        }
      }, "path---tapd-in-black-friday-cyber-monday-customer-service");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-black-friday-cyber-monday-customer-service!./.cache/json/tapd-in-black-friday-cyber-monday-customer-service.json
// module id = 811
// module chunks = 231608221292675